import { render, staticRenderFns } from "./DropdownDragHandle.vue?vue&type=template&id=948d6f58&"
import script from "./DropdownDragHandle.vue?vue&type=script&lang=ts&"
export * from "./DropdownDragHandle.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownDragHandle.vue?vue&type=style&index=0&id=948d6f58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports